/**
 * สร้างข้อความ QR พร้อมเพย์ (มาตรฐาน EMVCo ของ ธปท.) ให้แอปธนาคารสแกน
 *
 * QR ในโหมดแอปทรูเป็นลิงก์รับเงินของทรู แอปธนาคารสแกนแล้วขึ้น "ไม่ถูกต้อง"
 * โหมดโอนจากธนาคารจึงต้องใช้ QR แบบนี้แทน และฝังยอดเศษสตางค์ไว้ในตัว
 * ลูกค้าไม่ต้องพิมพ์ยอดเอง ซึ่งเป็นจุดที่พลาดบ่อยที่สุด
 *
 * target รับได้ 2 แบบ:
 *   เบอร์โทร 10 หลัก        → แท็ก 01 (0066 + เบอร์ตัด 0 หน้า)
 *   e-Wallet ID 15 หลัก     → แท็ก 03 (เช่นพร้อมเพย์ของทรูมันนี่ วอลเล็ท)
 */

const field = (id: string, value: string) =>
  `${id}${String(value.length).padStart(2, "0")}${value}`;

/** CRC-16/CCITT-FALSE (poly 0x1021, init 0xFFFF) ตามสเปก EMVCo */
function crc16(payload: string): string {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i += 1) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let bit = 0; bit < 8; bit += 1) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

export function promptpayPayload(target: string, amountBaht?: string | number): string | null {
  const digits = target.replace(/\D/g, "");
  let account: string;
  if (digits.length === 10 && digits.startsWith("0")) {
    account = field("01", `0066${digits.slice(1)}`);
  } else if (digits.length === 15) {
    account = field("03", digits);
  } else {
    return null;
  }

  const amount = amountBaht === undefined ? NaN : Number(amountBaht);
  const hasAmount = Number.isFinite(amount) && amount > 0;

  const body =
    field("00", "01") +
    // 12 = ใช้ครั้งเดียว (มียอด) · 11 = ใช้ซ้ำได้
    field("01", hasAmount ? "12" : "11") +
    field("29", field("00", "A000000677010111") + account) +
    field("53", "764") +
    (hasAmount ? field("54", amount.toFixed(2)) : "") +
    field("58", "TH") +
    "6304";
  return body + crc16(body);
}
